import { render, staticRenderFns } from "./Habilitacao.vue?vue&type=template&id=24be8726&scoped=true&"
import script from "./Habilitacao.vue?vue&type=script&lang=js&"
export * from "./Habilitacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24be8726",
  null
  
)

export default component.exports